import React from 'react';
import { INVENTORY_STATUS } from '../../hooks/useInventory';
import { MealPlanTab } from '../Hub/Kitchen';

/**
 * MealPlanWidget - Weekly meal planning widget
 * 
 * Thin wrapper around MealPlanTab.
 * State is managed by useMealPlan hook in App.js for sync with chat.
 * 
 * Receives data and handlers from props (passed through from App.js)
 */
export default function MealPlanWidget({
  // Data
  stockedItems = [],
  currentState = {},
  // Meal plan state from useMealPlan hook
  meals = [],
  weekStart,
  isLoading = false,
  isSaving = false,
  // Handlers
  onAddMeal,
  onRemoveMeal,
  onSkipDay,
  onClearDay,
  onWeekChange,
  onAddToShoppingList,
  onAddItem,
  // UI
  showToast
}) {
  // Handle adding item to shopping list
  const handleAddToShoppingList = (item) => {
    if (onAddItem) {
      onAddItem({
        ...item,
        status: INVENTORY_STATUS.needToBuy
      });
    } else if (onAddToShoppingList) {
      onAddToShoppingList(item);
    }
  };

  return (
    <MealPlanTab
      stockedItems={stockedItems}
      currentState={currentState}
      onAddToShoppingList={handleAddToShoppingList}
      showToast={showToast}
      // Meal plan state from hook
      meals={meals}
      weekStart={weekStart}
      isLoading={isLoading}
      isSaving={isSaving}
      onAddMeal={onAddMeal}
      onRemoveMeal={onRemoveMeal}
      onSkipDay={onSkipDay}
      onClearDay={onClearDay}
      onWeekChange={onWeekChange}
    />
  );
}
